import { SearchIcon } from 'assets/icons';
import { useBlogContext } from 'context/BlogContext';
import { BBINDIGO, GRAY30, GRAY70, GRAYBG } from 'global-styles';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const SearchForm = () => {
  const { dispatch } = useBlogContext();
  const { locale } = useRouter();
  const [searchDraft, setSearchDraft] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    dispatch({
      type: 'change',
      newState: { search: searchDraft, currPageNum: 1 },
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    const value = target.value;

    setSearchDraft(value);
  };

  useEffect(() => {
    if (searchDraft === '')
      dispatch({ type: 'change', newState: { search: '' } });
  }, [searchDraft, dispatch]);

  return (
    <SearchFormContainer onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder={
          locale === 'en' ? 'Enter keyword' : '검색어를 입력해주세요.'
        }
        value={searchDraft}
        onChange={handleChange}
        spellCheck={false}
      />
      <button>
        <SearchIcon />
      </button>
    </SearchFormContainer>
  );
};

export default SearchForm;

export const SearchFormContainer = styled.form`
  width: 280px;
  height: 48px;
  background: ${GRAYBG};
  border: 1px solid ${GRAY70};
  border-radius: 4px;
  display: flex;
  & > * {
    flex-shrink: 0;
  }
  & > input {
    border-radius: 4px;
    width: calc(100% - 44px);
    border: none;
    background: transparent;
    padding-left: 12px;
    color: ${GRAY30};
    ::placeholder {
      font-size: 15x;
      line-height: 20px;
      color: ${GRAY70};
    }
  }
  & > input:focus {
    outline: 1px solid ${BBINDIGO};
  }
  & > button {
    width: 44px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 599px) {
    width: 200px;
  }
`;
